import { StaticImageData } from 'next/image';
import { TArticleId } from '@portals/help-center-core';

export enum ECardType {
  COMPANY = 'company',
  MORE = 'more',
  SHARE_STORY = 'share-story',
}

export enum EVariant {
  YELLOW = 'yellow',
  ORANGE = 'orange',
  BLUE = 'blue',
  PURPLE = 'purple',
  PINK = 'pink',
  OTHER = 'other',
}

export type TCard = {
  cardType: ECardType;
  variant: EVariant;
  title: string;
  name?: string;
  description?: string;
  button: string;
  image?: StaticImageData;
  stageId?: TArticleId;
  prodId?: TArticleId;
  link?: string;
  blockName: string;
};

export type TSuccessStoriesConfig = {
  title: string;
  cards: Array<TCard>;
};
